import ModalFooterDefault from 'src/components/Modal/partials/ModalFooter/ModalFooterDefault.component';
import { ModalHeader } from 'src/components/Modal/partials/ModalHeader/ModalHeader.component';
import withConnectedModal from 'src/components/Modal/WithConnectedModal';
import MonitoringDetailModalBody from './MonitoringDetailModalBody.component';

export default withConnectedModal({
  showOnMount: true,
  hideOnUnmount: true,
  modalName: 'SteppeModal',
  headerComponent: ModalHeader,
  bodyComponent: MonitoringDetailModalBody,
  footerComponent: ModalFooterDefault,
});
